import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "relative block mt-3 text-center border border-clay-500 md:text-left md:inline-block sm:border-0 sm:mt-0"
}
const _hoisted_2 = { class: "flex items-start justify-center min-h-full p-4 text-center md:items-center sm:p-0" }
const _hoisted_3 = { class: "relative bg-zinc-50" }
const _hoisted_4 = { class: "absolute top-0 right-0 z-40 block pt-4 pr-4" }
const _hoisted_5 = { class: "relative h-24 overflow-hidden bg-electric-600 md:absolute md:left-0 md:h-full md:w-1/3" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "relative py-6 mx-auto border-2 rounded-b-lg max-w-7xl sm:py-12 lg:px-8 lg:py-12 border-electric-500" }
const _hoisted_8 = { class: "pl-6 md:ml-auto md:w-2/3" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "px-8 space-y-3 sm:space-y-6" }
const _hoisted_11 = { class: "mt-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-lg font-medium text-gray-700"
}
const _hoisted_13 = {
  key: 1,
  class: "text-lg font-medium text-gray-700"
}
const _hoisted_14 = { class: "px-8 mt-8 space-y-3 text-center" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "pb-6 space-y-4 text-center sm:px-6" }
const _hoisted_18 = { class: "mt-2" }
const _hoisted_19 = { class: "text-lg font-medium text-gray-700" }

import {computed, PropType, ref} from "vue";
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {store} from "@/store";
import {LockClosedIcon} from "@heroicons/vue/20/solid";


enum ContentFor {
    AtLeastBasic = 'AtLeastBasic',
    ProOnly = 'ProOnly'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'WalledOffFilter',
  props: {
    filterTitle: String,
    contentFor: {
        type: String as PropType<ContentFor>,
        default: 'AtLeastBasic'
    }
},
  setup(__props) {


// @ts-ignore
const props = __props;

const contentFor: ContentFor = props.contentFor;

const subscriptionType = computed(() => {
    switch(store.saUserSession.subscriptionType) {
        case 'free':
            return 'basic';
        case 'pro':
            return 'pro';
        default:
            return 'non-member';
    }
})

const openDialog = ref(false);

const redirectUrl = () => {
    return window.location.href.substring(window.location.origin.length);
}
const imgUrl = () => {
    return `/public/assets/img/walled-off-cta-${contentFor.toString().toLowerCase()}-subscription-${subscriptionType.value}.jpg`;
}
const cssClasses = () => {
    return `${contentFor.toString().toLowerCase()} subscription-${subscriptionType.value}`;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (subscriptionType.value === 'pro')
      ? _renderSlot(_ctx.$slots, "pro", { key: 0 })
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openDialog.value = true), ["prevent"])),
            class: "inline-flex justify-center min-w-full px-4 py-2 font-medium text-gray-700 uppercase text-md group hover:text-gray-900 sm:py-0"
          }, [
            _createElementVNode("span", null, _toDisplayString(props.filterTitle), 1),
            _createVNode(_unref(LockClosedIcon), {
              class: "w-4 h-4 ml-1 -mr-1 text-gray-400 shrink-0 group-hover:text-clay-800",
              "aria-hidden": "true"
            })
          ])
        ])),
    _createVNode(_unref(TransitionRoot), {
      show: openDialog.value,
      as: "template"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-40",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (openDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" }, null, -1)
              ])),
              _: 1
            }),
            _createElementVNode("div", {
              class: _normalizeClass(["fixed inset-0 z-10 overflow-y-auto", cssClasses()])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative overflow-hidden text-left transition-all transform rounded-lg shadow-xl sm:my-8 sm:w-full sm:max-w-3xl bg-white" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                              class: "text-gray-400 bg-white rounded-md hover:text-gray-600 focus:outline-hidden",
                              type: "button",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (openDialog.value = false))
                            }, _cache[4] || (_cache[4] = [
                              _createElementVNode("span", { class: "sr-only" }, "Close", -1),
                              _createElementVNode("svg", {
                                class: "w-6 h-6",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "1.5",
                                viewBox: "0 0 24 24",
                                xmlns: "http://www.w3.org/2000/svg"
                              }, [
                                _createElementVNode("path", {
                                  d: "M6 18L18 6M6 6l12 12",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round"
                                })
                              ], -1)
                            ]))
                          ]),
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("img", {
                              class: "object-cover w-full h-full",
                              src: imgUrl(),
                              alt: ""
                            }, null, 8, _hoisted_6),
                            _cache[5] || (_cache[5] = _createElementVNode("svg", {
                              viewBox: "0 0 926 676",
                              "aria-hidden": "true",
                              class: "absolute -bottom-24 left-24 w-[57.875rem] transform-gpu blur-[118px]"
                            }, [
                              _createElementVNode("path", {
                                fill: "url(#60c3c621-93e0-4a09-a0e6-4c228a0116d8)",
                                "fill-opacity": ".4",
                                d: "m254.325 516.708-90.89 158.331L0 436.427l254.325 80.281 163.691-285.15c1.048 131.759 36.144 345.144 168.149 144.613C751.171 125.508 707.17-93.823 826.603 41.15c95.546 107.978 104.766 294.048 97.432 373.585L685.481 297.694l16.974 360.474-448.13-141.46Z"
                              }),
                              _createElementVNode("defs", null, [
                                _createElementVNode("linearGradient", {
                                  id: "60c3c621-93e0-4a09-a0e6-4c228a0116d8",
                                  x1: "926.392",
                                  x2: "-109.635",
                                  y1: ".176",
                                  y2: "321.024",
                                  gradientUnits: "userSpaceOnUse"
                                }, [
                                  _createElementVNode("stop", { "stop-color": "#776FFF" }),
                                  _createElementVNode("stop", {
                                    offset: "1",
                                    "stop-color": "#FF4694"
                                  })
                                ])
                              ])
                            ], -1))
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              (subscriptionType.value === 'non-member')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createVNode(_unref(DialogTitle), {
                                        as: "h3",
                                        class: "mt-4 text-2xl font-extrabold tracking-tight sm:mt-8 font-display text-clay-900 sm:text-4xl"
                                      }, {
                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                          _createElementVNode("span", { class: "block text-electric-600" }, "Hello Stranger!", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_11, [
                                        (_unref(contentFor) ===  ContentFor.AtLeastBasic)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                              _cache[8] || (_cache[8] = _createElementVNode("a", { href: "/signup" }, "Join the StageAgent community", -1)),
                                              _renderSlot(_ctx.$slots, "content-title", {}, () => [
                                                _cache[7] || (_cache[7] = _createTextVNode("to unlock amazing theatre resources! "))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_unref(contentFor) ===  ContentFor.ProOnly)
                                          ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                              _cache[10] || (_cache[10] = _createElementVNode("a", { href: "/signup" }, "Sign up for StageAgent PRO", -1)),
                                              _renderSlot(_ctx.$slots, "content-title", {}, () => [
                                                _cache[9] || (_cache[9] = _createTextVNode("to unlock amazing theatre resources! "))
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                      _cache[12] || (_cache[12] = _createElementVNode("a", {
                                        href: "/signup",
                                        class: "block w-full px-3 py-2 text-sm font-semibold rounded-full shadow-sm bg-gradient-to-r from-electric-500 via-electric-800 to-electric-600 bg-electric-600 text-white hover:bg-electric-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-clay-600"
                                      }, "Sign Up", -1)),
                                      _createElementVNode("p", null, [
                                        _createElementVNode("a", {
                                          href: `/login?redirect=${redirectUrl()}`,
                                          class: "text-sm font-semibold text-gray-700 bg-white hover:text-gray-900 sm:mt-0"
                                        }, _cache[11] || (_cache[11] = [
                                          _createTextVNode("Already a Member? "),
                                          _createElementVNode("span", { class: "underline" }, "Login", -1)
                                        ]), 8, _hoisted_15)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (subscriptionType.value === 'basic')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                      _createVNode(_unref(DialogTitle), {
                                        as: "h3",
                                        class: "mt-8 text-5xl font-extrabold tracking-tight font-display text-clay-900 sm:text-4xl"
                                      }, {
                                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                                          _createElementVNode("span", { class: "block text-electric-600" }, "Upgrade to PRO", -1)
                                        ])),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_18, [
                                        _createElementVNode("p", _hoisted_19, [
                                          _cache[15] || (_cache[15] = _createElementVNode("a", { href: "/membership/upgrade" }, "Upgrade to PRO", -1)),
                                          _renderSlot(_ctx.$slots, "content-title", {}, () => [
                                            _cache[14] || (_cache[14] = _createTextVNode("to unlock amazing theatre resources! "))
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "px-8 mt-8 space-y-3 text-center" }, [
                                      _createElementVNode("a", {
                                        class: "block w-full px-3 py-2 text-sm font-semibold rounded-full shadow-sm bg-gradient-to-r from-electric-500 via-electric-800 to-electric-600 bg-electric-600 text-white hover:bg-electric-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-electric-600",
                                        href: "/membership/upgrade"
                                      }, "Upgrade")
                                    ], -1))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]),
                      _: 3
                    })
                  ]),
                  _: 3
                })
              ])
            ], 2)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"])
  ], 64))
}
}

})